import { render, staticRenderFns } from "./PendingValidationBanner.vue?vue&type=template&id=2726bb52&scoped=true"
import script from "./PendingValidationBanner.vue?vue&type=script&lang=ts"
export * from "./PendingValidationBanner.vue?vue&type=script&lang=ts"
import style0 from "./PendingValidationBanner.vue?vue&type=style&index=0&id=2726bb52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2726bb52",
  null
  
)

export default component.exports